export default __webpack_public_path__ + "static/media/memories.61260754.png";